import { render, staticRenderFns } from "./review-order.vue?vue&type=template&id=78155d94&"
import script from "./review-order.vue?vue&type=script&lang=js&"
export * from "./review-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports